import React from 'react';

import { Badge } from '@/components/ui/badge';

interface ConfidenceBadgeProps {
  score?: number;
}

export const ConfidenceBadge = ({ score }: ConfidenceBadgeProps) => {
  const formattedScore = `${score}%`;
  if (!score || score > 100) {
    return <Badge variant="disabled">N/A</Badge>;
  } else if (score >= 80) {
    return <Badge variant="success">{formattedScore}</Badge>;
  } else if (score >= 40 && score < 80) {
    return <Badge variant="warning">{formattedScore}</Badge>;
  } else {
    return <Badge variant="disabled">N/A</Badge>;
  }
};
